export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/book-occurrence/resources/components.js